import { TeamsTableHeader } from '../constants/headers';
import { ITeamMember } from '@types';

export function compareMembers(
  a: ITeamMember & { deliveryManager?: ITeamMember },
  b: ITeamMember & { deliveryManager?: ITeamMember },
  sortKey: TeamsTableHeader,
  sortDir: 'asc' | 'desc',
): number {
  let res = 0;
  switch (sortKey) {
    case TeamsTableHeader.DeliveryManager: {
      const nameA = a?.deliveryManager?.fullName?.trim?.() || '';
      const nameB = b?.deliveryManager?.fullName?.trim?.() || '';
      res = nameA.localeCompare(nameB);
      break;
    }
    case TeamsTableHeader.Rate: {
      const rateA = typeof a?.rate === 'number' ? a.rate : 0;
      const rateB = typeof b?.rate === 'number' ? b.rate : 0;
      res = rateA - rateB;
      break;
    }
    case TeamsTableHeader.NextEvaluation: {
      const aDate = a?.evaluations?.[0]?.evaluationDate || '';
      const bDate = b?.evaluations?.[0]?.evaluationDate || '';
      res = bDate.localeCompare(aDate);
      break;
    }
    case TeamsTableHeader.Allocation: {
      const allocA = typeof a?.allocation === 'number' ? a.allocation : 0;
      const allocB = typeof b?.allocation === 'number' ? b.allocation : 0;
      res = allocA - allocB;
      break;
    }
    // case TeamsTableHeader.HappinessScore: {
    //   const aScore = a?.happiness?.[0]?.score ?? 0;
    //   const bScore = b?.happiness?.[0]?.score ?? 0;
    //   res = aScore - bScore;
    //   break;
    // }
    case TeamsTableHeader.SowStartDate: {
      const aDate = a?.startedAt || '';
      const bDate = b?.startedAt || '';
      res = aDate.localeCompare(bDate);
      break;
    }
    case TeamsTableHeader.SowEndDate: {
      const aDate = a?.endedAt || '';
      const bDate = b?.endedAt || '';
      res = aDate.localeCompare(bDate);
      break;
    }
    default: {
      const nameA = a?.fullName?.trim?.() || '';
      const nameB = b?.fullName?.trim?.() || '';
      res = nameA.localeCompare(nameB);
    }
  }
  return sortDir === 'asc' ? res : -res;
}
